import { Platform, Status } from "./enums";
import johnDeereOpsCenterLogo from "@/assets/images/JDOC-tm-default.svg";

export type Connection = {
    id: number;
    platform: Platform;
    status: Status;
};

export type UserConnection = {
    id: number;
    user: number;
    username: string;
    connection: number | Platform;
    platform: Platform;
    action_required: boolean;
};

export type FieldConnection = {
    id: number;
    field: number;
    status: string;
    platform_field_name: string;
    user_connection: UserConnection;
    platform_field_id: string;
};

export type IrrigationSystemConnection = {
    id: number;
    irrigation_system: number;
    status: string;
    platform_irrigation_system_name: string;
    user_connection: UserConnection;
    platform_irrigation_system_id: string;
};

export const PLATFORM_LOGOS: Record<Platform, string> = {
    [Platform.JohnDeere]: johnDeereOpsCenterLogo,
    [Platform.CNHI]: "/assets/images/CaseNewHolland_CombinedLogos.png",
    [Platform.FieldView]:
        "/assets/images/Climate_FieldView_Horizontal_thumb.svg",
    [Platform.FieldNET]: "/assets/images/fieldnet-logo.svg",
};

export type LeafField = {
    id: string;
    leafUserId: string;
    boundaries: string[];
    providerName: string;
    providerFieldId: string;
    providerBoundaryId: string;
    providerFieldName: string;
    providerFarmName: string;
    linked: boolean;
    providerGrowerName?: string;
    name?: string;
};
